// shared/ui/guardarArchivo.js  (helper de navegador: dispara la descarga de un Blob)

/** Guarda `blob` como `nombre` con un <a download> temporal y libera el objectURL. */
export const guardarArchivo = (blob, nombre) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nombre;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
};
